var map = {
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 1/ANTENNA 1 BW.svg": 818,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 1/ANTENNA 1 GREEN.svg": 819,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 1/ANTENNA 1 LIME.svg": 820,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 1/ANTENNA 1 PURPLE.svg": 821,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 1/ANTENNA 1 RED.svg": 822,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 2/ANTENNA 2 BW.svg": 823,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 2/ANTENNA 2 GREEN.svg": 824,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 2/ANTENNA 2 LIME.svg": 825,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 2/ANTENNA 2 PURPLE.svg": 826,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 2/ANTENNA 2 RED.svg": 827,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 3/ANTENNA 3 BW.svg": 828,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 3/ANTENNA 3 GREEN.svg": 829,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 3/ANTENNA 3 LIME.svg": 830,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 3/ANTENNA 3 PURPLE.svg": 831,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 3/ANTENNA 3 RED.svg": 832,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 4/ANTENNA 4 BW.svg": 833,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 4/ANTENNA 4 GREEN.svg": 834,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 4/ANTENNA 4 LIME.svg": 835,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 4/ANTENNA 4 PURPLE.svg": 836,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 4/ANTENNA 4 RED.svg": 837,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 5/ANTENNA 5 BW.svg": 838,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 5/ANTENNA 5 GREEN.svg": 839,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 5/ANTENNA 5 LIME.svg": 840,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 5/ANTENNA 5 PURPLE.svg": 841,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA 5/ANTENNA 5 RED.svg": 842,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA FLOWER/ANTENNA FLOWER BW.svg": 843,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA FLOWER/ANTENNA FLOWER GREEN.svg": 844,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA FLOWER/ANTENNA FLOWER LIME.svg": 845,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA FLOWER/ANTENNA FLOWER PURPLE.svg": 846,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA FLOWER/ANTENNA FLOWER RED.svg": 847,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA PALM/ANTENNA PALMA BW.svg": 848,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA PALM/ANTENNA PALMA GREEN.svg": 849,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA PALM/ANTENNA PALMA LIME.svg": 850,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA PALM/ANTENNA PALMA PURPLE.svg": 851,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA PALM/ANTENNA PALMA RED.svg": 852,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO 2/ANTENNA RADIO 2 BW.svg": 853,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO 2/ANTENNA RADIO 2 GREEN.svg": 854,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO 2/ANTENNA RADIO 2 LIME.svg": 855,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO 2/ANTENNA RADIO 2 PURPLE.svg": 856,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO 2/ANTENNA RADIO 2 RED.svg": 857,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO/ANTENNA RADIO BW.svg": 858,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO/ANTENNA RADIO GREEN.svg": 859,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO/ANTENNA RADIO LIME.svg": 860,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO/ANTENNA RADIO PURPLE.svg": 861,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA RADIO/ANTENNA RADIO RED.svg": 862,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA TWIRL/ANTENNA TWIRL BW.svg": 863,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA TWIRL/ANTENNA TWIRL GREEN.svg": 864,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA TWIRL/ANTENNA TWIRL LIME.svg": 865,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA TWIRL/ANTENNA TWIRL PURPLE.svg": 866,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA TWIRL/ANTENNA TWIRL RED.svg": 867,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA WAVES/ANTENNA WAVES BW.svg": 868,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA WAVES/ANTENNA WAVES GREEN.svg": 869,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA WAVES/ANTENNA WAVES LIME.svg": 870,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA WAVES/ANTENNA WAVES PURPLE.svg": 871,
	"./BASIC ELEMENTS/ANTENNA/ANTENNA WAVES/ANTENNA WAVES RED.svg": 872,
	"./BASIC ELEMENTS/COMBO/COMBO FLOWER/COMBO FLOWER BW.svg": 873,
	"./BASIC ELEMENTS/COMBO/COMBO FLOWER/COMBO FLOWER GREEN.svg": 874,
	"./BASIC ELEMENTS/COMBO/COMBO FLOWER/COMBO FLOWER LIME.svg": 875,
	"./BASIC ELEMENTS/COMBO/COMBO FLOWER/COMBO FLOWER PURPLE.svg": 876,
	"./BASIC ELEMENTS/COMBO/COMBO FLOWER/COMBO FLOWER RED.svg": 877,
	"./BASIC ELEMENTS/COMBO/COMBO HEART/COMBO HEART BW.svg": 878,
	"./BASIC ELEMENTS/COMBO/COMBO HEART/COMBO HEART GREEN.svg": 879,
	"./BASIC ELEMENTS/COMBO/COMBO HEART/COMBO HEART LIME.svg": 880,
	"./BASIC ELEMENTS/COMBO/COMBO HEART/COMBO HEART PURPLE.svg": 881,
	"./BASIC ELEMENTS/COMBO/COMBO HEART/COMBO HEART RED.svg": 882,
	"./BASIC ELEMENTS/COMBO/COMBO PALM/COMBO PALM BW.svg": 883,
	"./BASIC ELEMENTS/COMBO/COMBO PALM/COMBO PALM GREEN.svg": 884,
	"./BASIC ELEMENTS/COMBO/COMBO PALM/COMBO PALM LIME.svg": 885,
	"./BASIC ELEMENTS/COMBO/COMBO PALM/COMBO PALM PURPLE.svg": 886,
	"./BASIC ELEMENTS/COMBO/COMBO PALM/COMBO PALM RED.svg": 887,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO 2/COMBO RADIO 2 BW.svg": 888,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO 2/COMBO RADIO 2 GREEN.svg": 889,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO 2/COMBO RADIO 2 LIME.svg": 890,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO 2/COMBO RADIO 2 PURPLE.svg": 891,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO 2/COMBO RADIO 2 RED.svg": 892,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO/COMBO RADIO BW.svg": 893,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO/COMBO RADIO GREEN.svg": 894,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO/COMBO RADIO LIME.svg": 895,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO/COMBO RADIO PURPLE.svg": 896,
	"./BASIC ELEMENTS/COMBO/COMBO RADIO/COMBO RADIO RED.svg": 897,
	"./BASIC ELEMENTS/COMBO/COMBO RAIBOW/COMBO RAINBOW BW.svg": 898,
	"./BASIC ELEMENTS/COMBO/COMBO RAIBOW/COMBO RAINBOW GREEN.svg": 899,
	"./BASIC ELEMENTS/COMBO/COMBO RAIBOW/COMBO RAINBOW LIME.svg": 900,
	"./BASIC ELEMENTS/COMBO/COMBO RAIBOW/COMBO RAINBOW PURPLE.svg": 901,
	"./BASIC ELEMENTS/COMBO/COMBO RAIBOW/COMBO RAINBOW RED.svg": 902,
	"./BASIC ELEMENTS/COMBO/COMBO SPIRAL/COMBO SPIRAL BW.svg": 903,
	"./BASIC ELEMENTS/COMBO/COMBO SPIRAL/COMBO SPIRAL GREEN.svg": 904,
	"./BASIC ELEMENTS/COMBO/COMBO SPIRAL/COMBO SPIRAL LIME.svg": 905,
	"./BASIC ELEMENTS/COMBO/COMBO SPIRAL/COMBO SPIRAL PURPLE.svg": 906,
	"./BASIC ELEMENTS/COMBO/COMBO SPIRAL/COMBO SPIRAL RED.svg": 907,
	"./BASIC ELEMENTS/COMBO/COMBO TWIRL/COMBO TWIRL BW.svg": 908,
	"./BASIC ELEMENTS/COMBO/COMBO TWIRL/COMBO TWIRL GREEN.svg": 909,
	"./BASIC ELEMENTS/COMBO/COMBO TWIRL/COMBO TWIRL LIME.svg": 910,
	"./BASIC ELEMENTS/COMBO/COMBO TWIRL/COMBO TWIRL PURPLE.svg": 911,
	"./BASIC ELEMENTS/COMBO/COMBO TWIRL/COMBO TWIRL RED.svg": 912,
	"./BASIC ELEMENTS/COMBO/COMBO WAVES/COMBO WAVES BW.svg": 913,
	"./BASIC ELEMENTS/COMBO/COMBO WAVES/COMBO WAVES GREEN.svg": 914,
	"./BASIC ELEMENTS/COMBO/COMBO WAVES/COMBO WAVES LIME.svg": 915,
	"./BASIC ELEMENTS/COMBO/COMBO WAVES/COMBO WAVES PURPLE.svg": 916,
	"./BASIC ELEMENTS/COMBO/COMBO WAVES/COMBO WAVES RED.svg": 917,
	"./BASIC ELEMENTS/SINGLE DEVICE SX/SINGLE DEVICE SX BW.svg": 918,
	"./BASIC ELEMENTS/SINGLE DEVICE SX/SINGLE DEVICE SX GREEN.svg": 919,
	"./BASIC ELEMENTS/SINGLE DEVICE SX/SINGLE DEVICE SX LIME.svg": 920,
	"./BASIC ELEMENTS/SINGLE DEVICE SX/SINGLE DEVICE SX PURPLE.svg": 921,
	"./BASIC ELEMENTS/SINGLE DEVICE SX/SINGLE DEVICE SX RED.svg": 922,
	"./FESTIVITIES/APRL FOOLS SPCTACLES.svg": 923,
	"./FESTIVITIES/COCHLEAR DAY.svg": 924,
	"./FESTIVITIES/EID MUBARAK.svg": 925,
	"./FESTIVITIES/FATHERS DAY.svg": 926,
	"./FESTIVITIES/GRANDPARENTS DAY.svg": 927,
	"./FESTIVITIES/HALLOWEEN.svg": 928,
	"./FESTIVITIES/HAPPY DIWALI.svg": 929,
	"./FESTIVITIES/LABOUR DAY.svg": 930,
	"./FESTIVITIES/MAY DAY.svg": 931,
	"./FESTIVITIES/MERRY CHRISTMAS.svg": 932,
	"./FESTIVITIES/MOTHERS DAY.svg": 933,
	"./FESTIVITIES/NEW YEAR.svg": 934,
	"./FESTIVITIES/REINDEER.svg": 935,
	"./FESTIVITIES/SANTAS BEARD.svg": 936,
	"./FESTIVITIES/SANTAS HAT 2.svg": 937,
	"./FESTIVITIES/SANTAS HAT.svg": 938,
	"./FESTIVITIES/VAL DAY HEART.svg": 939,
	"./FESTIVITIES/VALENTINE'S DAY.svg": 940,
	"./FESTIVITIES/WORLD HEARING DAY.svg": 941,
	"./FUN ELEMENTS/ANGEL SHADES/ANGEL SHADES BW.svg": 942,
	"./FUN ELEMENTS/ANGEL SHADES/ANGEL SHADES GREEN.svg": 943,
	"./FUN ELEMENTS/ANGEL SHADES/ANGEL SHADES LIME.svg": 944,
	"./FUN ELEMENTS/ANGEL SHADES/ANGEL SHADES PURPLE.svg": 945,
	"./FUN ELEMENTS/ANGEL SHADES/ANGEL SHADES RED.svg": 946,
	"./FUN ELEMENTS/BASEBALL CAP/BASEBALL CAP BN.svg": 947,
	"./FUN ELEMENTS/BASEBALL CAP/BASEBALL CAP GREEN.svg": 948,
	"./FUN ELEMENTS/BASEBALL CAP/BASEBALL CAP LIME.svg": 949,
	"./FUN ELEMENTS/BASEBALL CAP/BASEBALL CAP PURPLE.svg": 950,
	"./FUN ELEMENTS/BASEBALL CAP/BASEBALL CAP RED.svg": 951,
	"./FUN ELEMENTS/BEARD 1.svg": 952,
	"./FUN ELEMENTS/BEARD 2.svg": 953,
	"./FUN ELEMENTS/BIRD SHADES/BIRD SHADES BW.svg": 954,
	"./FUN ELEMENTS/BIRD SHADES/BIRD SHADES GREEN.svg": 955,
	"./FUN ELEMENTS/BIRD SHADES/BIRD SHADES LIME.svg": 956,
	"./FUN ELEMENTS/BIRD SHADES/BIRD SHADES PURPLE.svg": 957,
	"./FUN ELEMENTS/BIRD SHADES/BIRD SHADES RED.svg": 958,
	"./FUN ELEMENTS/BOWTIE 1/BOWTIE 1 BW.svg": 959,
	"./FUN ELEMENTS/BOWTIE 1/BOWTIE 1 GREEN.svg": 960,
	"./FUN ELEMENTS/BOWTIE 1/BOWTIE 1 LIME.svg": 961,
	"./FUN ELEMENTS/BOWTIE 1/BOWTIE 1 PURPLE.svg": 962,
	"./FUN ELEMENTS/BOWTIE 1/BOWTIE 1 RED.svg": 963,
	"./FUN ELEMENTS/BOWTIE 2/BOWTIE 2 BW.svg": 964,
	"./FUN ELEMENTS/BOWTIE 2/BOWTIE 2 GREEN.svg": 965,
	"./FUN ELEMENTS/BOWTIE 2/BOWTIE 2 LIME.svg": 966,
	"./FUN ELEMENTS/BOWTIE 2/BOWTIE 2 PURPLE.svg": 967,
	"./FUN ELEMENTS/BOWTIE 2/BOWTIE 2 RED.svg": 968,
	"./FUN ELEMENTS/BOWTIE 3/BOWTIE 3 BW.svg": 969,
	"./FUN ELEMENTS/BOWTIE 3/BOWTIE 3 GREEN.svg": 970,
	"./FUN ELEMENTS/BOWTIE 3/BOWTIE 3 LIME.svg": 971,
	"./FUN ELEMENTS/BOWTIE 3/BOWTIE 3 PURPLE.svg": 972,
	"./FUN ELEMENTS/BOWTIE 3/BOWTIE 3 RED.svg": 973,
	"./FUN ELEMENTS/CAT.svg": 974,
	"./FUN ELEMENTS/COLLAR/COLLAR BW.svg": 975,
	"./FUN ELEMENTS/COLLAR/COLLAR GREEN.svg": 976,
	"./FUN ELEMENTS/COLLAR/COLLAR LIME.svg": 977,
	"./FUN ELEMENTS/COLLAR/COLLAR PURPLE.svg": 978,
	"./FUN ELEMENTS/COLLAR/COLLAR RED.svg": 979,
	"./FUN ELEMENTS/COWBOY HAT/COWBOY HAT BN.svg": 980,
	"./FUN ELEMENTS/COWBOY HAT/COWBOY HAT GREEN.svg": 981,
	"./FUN ELEMENTS/COWBOY HAT/COWBOY HAT LIME.svg": 982,
	"./FUN ELEMENTS/COWBOY HAT/COWBOY HAT PURPLE.svg": 983,
	"./FUN ELEMENTS/COWBOY HAT/COWBOY HAT RED.svg": 984,
	"./FUN ELEMENTS/CROWN/CROWN BN.svg": 985,
	"./FUN ELEMENTS/CROWN/CROWN GREEN.svg": 986,
	"./FUN ELEMENTS/CROWN/CROWN LIME.svg": 987,
	"./FUN ELEMENTS/CROWN/CROWN PURPLE.svg": 988,
	"./FUN ELEMENTS/CROWN/CROWN RED.svg": 989,
	"./FUN ELEMENTS/EARRINGS/EARRINGS BN.svg": 990,
	"./FUN ELEMENTS/EARRINGS/EARRINGS GREEN.svg": 991,
	"./FUN ELEMENTS/EARRINGS/EARRINGS LIME.svg": 992,
	"./FUN ELEMENTS/EARRINGS/EARRINGS PURPLE.svg": 993,
	"./FUN ELEMENTS/EARRINGS/EARRINGS RED.svg": 994,
	"./FUN ELEMENTS/ELEPHANT.svg": 995,
	"./FUN ELEMENTS/ETHNIC NECKLACE/ETHNIC NECKLACE BN.svg": 996,
	"./FUN ELEMENTS/ETHNIC NECKLACE/ETHNIC NECKLACE GREEN.svg": 997,
	"./FUN ELEMENTS/ETHNIC NECKLACE/ETHNIC NECKLACE LIME.svg": 998,
	"./FUN ELEMENTS/ETHNIC NECKLACE/ETHNIC NECKLACE PURPLE.svg": 999,
	"./FUN ELEMENTS/ETHNIC NECKLACE/ETHNIC NECKLACE RED.svg": 1000,
	"./FUN ELEMENTS/FATIMA NECKLACE/FATIMA NECKLACE BN.svg": 1001,
	"./FUN ELEMENTS/FATIMA NECKLACE/FATIMA NECKLACE GREEN.svg": 1002,
	"./FUN ELEMENTS/FATIMA NECKLACE/FATIMA NECKLACE LIME.svg": 1003,
	"./FUN ELEMENTS/FATIMA NECKLACE/FATIMA NECKLACE PURPLE.svg": 1004,
	"./FUN ELEMENTS/FATIMA NECKLACE/FATIMA NECKLACE RED.svg": 1005,
	"./FUN ELEMENTS/FLOWER HAT/FLOWER HAT BN.svg": 1006,
	"./FUN ELEMENTS/FLOWER HAT/FLOWER HAT GREEN.svg": 1007,
	"./FUN ELEMENTS/FLOWER HAT/FLOWER HAT LIME.svg": 1008,
	"./FUN ELEMENTS/FLOWER HAT/FLOWER HAT PURPLE.svg": 1009,
	"./FUN ELEMENTS/FLOWER HAT/FLOWER HAT RED.svg": 1010,
	"./FUN ELEMENTS/HEART SHADES/HEART SHADES BW.svg": 1011,
	"./FUN ELEMENTS/HEART SHADES/HEART SHADES GREEN.svg": 1012,
	"./FUN ELEMENTS/HEART SHADES/HEART SHADES LIME.svg": 1013,
	"./FUN ELEMENTS/HEART SHADES/HEART SHADES PURPLE.svg": 1014,
	"./FUN ELEMENTS/HEART SHADES/HEART SHADES RED.svg": 1015,
	"./FUN ELEMENTS/HP NECKLACE/HP NECKLACE BW.svg": 1016,
	"./FUN ELEMENTS/HP NECKLACE/HP NECKLACE RED.svg": 1017,
	"./FUN ELEMENTS/LADY HAT/LADY HAT BW.svg": 1018,
	"./FUN ELEMENTS/LADY HAT/LADY HAT GREEN.svg": 1019,
	"./FUN ELEMENTS/LADY HAT/LADY HAT LIME.svg": 1020,
	"./FUN ELEMENTS/LADY HAT/LADY HAT PURPLE.svg": 1021,
	"./FUN ELEMENTS/LADY HAT/LADY HAT RED.svg": 1022,
	"./FUN ELEMENTS/LIGHTING 1/LIGHTING 1 BW.svg": 1023,
	"./FUN ELEMENTS/LIGHTING 1/LIGHTING 1 GREEN.svg": 1024,
	"./FUN ELEMENTS/LIGHTING 1/LIGHTING 1 LIME.svg": 1025,
	"./FUN ELEMENTS/LIGHTING 1/LIGHTING 1 PURPLE.svg": 1026,
	"./FUN ELEMENTS/LIGHTING 1/LIGHTING 1 RED.svg": 1027,
	"./FUN ELEMENTS/LIGHTING 2/LIGHTING 2 BW.svg": 1028,
	"./FUN ELEMENTS/LIGHTING 2/LIGHTING 2 GREEN.svg": 1029,
	"./FUN ELEMENTS/LIGHTING 2/LIGHTING 2 LIME.svg": 1030,
	"./FUN ELEMENTS/LIGHTING 2/LIGHTING 2 PURPLE.svg": 1031,
	"./FUN ELEMENTS/LIGHTING 2/LIGHTING 2 RED.svg": 1032,
	"./FUN ELEMENTS/MOUSTACHES 1.svg": 1033,
	"./FUN ELEMENTS/MOUSTACHES 2.svg": 1034,
	"./FUN ELEMENTS/MOUSTACHES 3.svg": 1035,
	"./FUN ELEMENTS/MOUSTACHES SET 1/MOUSTACHES SET 1 BW.svg": 1036,
	"./FUN ELEMENTS/MOUSTACHES SET 1/MOUSTACHES SET 1 GREEN.svg": 1037,
	"./FUN ELEMENTS/MOUSTACHES SET 1/MOUSTACHES SET 1 LIME.svg": 1038,
	"./FUN ELEMENTS/MOUSTACHES SET 1/MOUSTACHES SET 1 PURPLE.svg": 1039,
	"./FUN ELEMENTS/MOUSTACHES SET 1/MOUSTACHES SET 1 RED.svg": 1040,
	"./FUN ELEMENTS/MOUSTACHES SET 2.svg": 1041,
	"./FUN ELEMENTS/MOUSTACHES SET 3.svg": 1042,
	"./FUN ELEMENTS/MOUSTACHES SET 4.svg": 1043,
	"./FUN ELEMENTS/PEARLS/PEARLSAsset 209.svg": 1044,
	"./FUN ELEMENTS/PEARLS/PEARLSAsset 210.svg": 1045,
	"./FUN ELEMENTS/PEARLS/PEARLSAsset 211.svg": 1046,
	"./FUN ELEMENTS/PEARLS/PEARLSAsset 212.svg": 1047,
	"./FUN ELEMENTS/PEARLS/PEARLSAsset 213.svg": 1048,
	"./FUN ELEMENTS/ROUND SHADES/ROUND SHADES BW.svg": 1049,
	"./FUN ELEMENTS/ROUND SHADES/ROUND SHADES GREEN.svg": 1050,
	"./FUN ELEMENTS/ROUND SHADES/ROUND SHADES LIME.svg": 1051,
	"./FUN ELEMENTS/ROUND SHADES/ROUND SHADES PURPLE.svg": 1052,
	"./FUN ELEMENTS/ROUND SHADES/ROUND SHADES RED.svg": 1053,
	"./FUN ELEMENTS/SINGLE EAR RING/SINGLE EAR RING BN.svg": 1054,
	"./FUN ELEMENTS/SINGLE EAR RING/SINGLE EAR RING GREEN.svg": 1055,
	"./FUN ELEMENTS/SINGLE EAR RING/SINGLE EAR RING LIME.svg": 1056,
	"./FUN ELEMENTS/SINGLE EAR RING/SINGLE EAR RING PURPLE.svg": 1057,
	"./FUN ELEMENTS/SINGLE EAR RING/SINGLE EAR RING RED.svg": 1058,
	"./FUN ELEMENTS/STAR SHADES/STAR SHADES BW.svg": 1059,
	"./FUN ELEMENTS/STAR SHADES/STAR SHADES GREEN.svg": 1060,
	"./FUN ELEMENTS/STAR SHADES/STAR SHADES LIME.svg": 1061,
	"./FUN ELEMENTS/STAR SHADES/STAR SHADES PURPLE.svg": 1062,
	"./FUN ELEMENTS/STAR SHADES/STAR SHADES RED.svg": 1063,
	"./FUN ELEMENTS/UNIFORM/UNIFORM BW.svg": 1064,
	"./FUN ELEMENTS/UNIFORM/UNIFORM GREEN.svg": 1065,
	"./FUN ELEMENTS/UNIFORM/UNIFORM LIME.svg": 1066,
	"./FUN ELEMENTS/UNIFORM/UNIFORM PURPLE.svg": 1067,
	"./FUN ELEMENTS/UNIFORM/UNIFORM RED.svg": 1068,
	"./FUN ELEMENTS/WINTER HAT/WINTER HAT BN.svg": 1069,
	"./FUN ELEMENTS/WINTER HAT/WINTER HAT GREEN.svg": 1070,
	"./FUN ELEMENTS/WINTER HAT/WINTER HAT LIME.svg": 1071,
	"./FUN ELEMENTS/WINTER HAT/WINTER HAT PURPLE.svg": 1072,
	"./FUN ELEMENTS/WINTER HAT/WINTER HAT RED.svg": 1073,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 1/BINDI 1 BW.svg": 1074,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 1/BINDI 1 GREEN.svg": 1075,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 1/BINDI 1 LIME.svg": 1076,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 1/BINDI 1 PURPLE.svg": 1077,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 1/BINDI 1 RED.svg": 1078,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 2/BINDI 2 BW.svg": 1079,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 2/BINDI 2 GREEN.svg": 1080,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 2/BINDI 2 LIME.svg": 1081,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 2/BINDI 2 PURPLE.svg": 1082,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 2/BINDI 2 RED.svg": 1083,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 3/BINDI 3 BW.svg": 1084,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 3/BINDI 3 GREEN.svg": 1085,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 3/BINDI 3 LIME.svg": 1086,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 3/BINDI 3 PURPLE.svg": 1087,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 3/BINDI 3 RED.svg": 1088,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 4/BINDI 4 BW.svg": 1089,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 4/BINDI 4 GREEN.svg": 1090,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 4/BINDI 4 LIME.svg": 1091,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 4/BINDI 4 PURPLE.svg": 1092,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 4/BINDI 4 RED.svg": 1093,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 5/BINDI 5 B.svg": 1094,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 5/BINDI 5 GREEN.svg": 1095,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 5/BINDI 5 LIME.svg": 1096,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 5/BINDI 5 PURPLE.svg": 1097,
	"./RELIGIOUS-CULTURAL ELEMENTS/BINDI 5/BINDI 5 RED.svg": 1098,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU DIWALI/HINDU DIWALI BW.svg": 1099,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU DIWALI/HINDU DIWALI GREEN.svg": 1100,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU DIWALI/HINDU DIWALI LIME.svg": 1101,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU DIWALI/HINDU DIWALI PURPLE.svg": 1102,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU DIWALI/HINDU DIWALI RED.svg": 1103,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU/HINDU BW.svg": 1104,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU/HINDU GREEN.svg": 1105,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU/HINDU LIME.svg": 1106,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU/HINDU PURPLE.svg": 1107,
	"./RELIGIOUS-CULTURAL ELEMENTS/HINDU/HINDU RED.svg": 1108,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH TURBAN/SIKH TURBAN BW.svg": 1109,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH TURBAN/SIKH TURBAN GREEN.svg": 1110,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH TURBAN/SIKH TURBAN LIME.svg": 1111,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH TURBAN/SIKH TURBAN PURPLE.svg": 1112,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH TURBAN/SIKH TURBAN RED.svg": 1113,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH/SIKH BW.svg": 1114,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH/SIKH GREEN.svg": 1115,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH/SIKH LIME.svg": 1116,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH/SIKH PURPLE.svg": 1117,
	"./RELIGIOUS-CULTURAL ELEMENTS/SIKH/SIKH RED.svg": 1118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;